"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

require("../styles/_upload-contract.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var VALID_EXTENSIONS = ['doc', 'docx', 'pdf'];

var UploadContract = /*#__PURE__*/function (_Component) {
  _inherits(UploadContract, _Component);

  function UploadContract(props) {
    var _this;

    _classCallCheck(this, UploadContract);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploadContract).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onFilesChange", function (files) {
      var disabled = _this.props.disabled;

      if (disabled || !files || !files.length) {
        return;
      }

      var _files$slice = files.slice(-1),
          _files$slice2 = _slicedToArray(_files$slice, 1),
          file = _files$slice2[0];

      _this.setState({
        file: file,
        isValidFile: VALID_EXTENSIONS.some(function (extension) {
          return file.extension === extension;
        })
      }, function () {
        var onUploadContract = _this.props.onUploadContract;
        var isValidFile = _this.state.isValidFile;
        onUploadContract({
          contract: file,
          isValidFile: isValidFile
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onErrorFile", function (_, file) {
      _this.onFilesChange([file]);
    });

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      var filePicker = _this.state.filePicker;

      if (ref && !filePicker) {
        _this.setState({
          filePicker: ref
        });
      }
    });

    _this.state = {
      file: void 0,
      filePicker: void 0,
      isValidFile: true
    };
    return _this;
  }

  _createClass(UploadContract, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          initialContract = _this$props.initialContract,
          disabled = _this$props.disabled;
      var _this$state = this.state,
          file = _this$state.file,
          filePicker = _this$state.filePicker,
          isValidFile = _this$state.isValidFile;
      var name = file || initialContract ? file && file.name || 'File' : 'NO CONTRACT FOUND';
      var description = !isValidFile ? 'Invalid file. File format must be .doc, .docx or .pdf.' : '';
      var buttonText = file || initialContract ? 'CHANGE' : 'ATTACH';
      return _react.default.createElement(_reactFiles.default, {
        className: (0, _classnames.default)('upload-contract', {
          'upload-contract--invalid-file': !isValidFile
        }),
        dropActiveClassName: "upload-contract--active",
        onChange: this.onFilesChange,
        accepts: ['.pdf', '.doc', '.docx'],
        maxFileSize: 10000000,
        minFileSize: 1,
        clickable: false,
        ref: this.setFilePickerRef,
        onError: this.onErrorFile
      }, _react.default.createElement(_commonReact.Form.TitledFormBlock, {
        title: title,
        defaultImage: "contract",
        hasSelectedItem: Boolean(initialContract || file)
      }, _react.default.createElement(_commonReact.Form.FormBlockDescription, {
        name: name,
        buttonText: buttonText,
        description: initialContract || file ? description : 'Cannot find any contracts assigned to this Organisation Account.',
        highlightedName: true,
        onClickButton: filePicker ? filePicker.openFileChooser : void 0,
        hideButton: disabled
      })));
    }
  }]);

  return UploadContract;
}(_react.Component);

exports.default = UploadContract;